import "./contactForm.css";

import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { notifSelectors } from "../../logic/rootSelectors";
import _contact from "../../logic/contact";
import { LS_ITEM, LOADING_STATE, PAGE_ROUTES } from "../../utils/stateTypes";

const EMPTY = {
  name: "",
  email: "",
  phone: "",
  subject: "",
  message: "",
  website: "",
};

//Boxed inputs like the original Wix form, used on the home and contact pages.
//"light" is for the orange home page section, "outlined" for the white contact page
const ContactForm = ({ variant = "light", sendLS, sendContactMessage }) => {
  const [form, setForm] = React.useState(EMPTY);
  const [hasAccepted, setHasAccepted] = React.useState(false);
  const [isSent, setIsSent] = React.useState(false);
  const idPrefix = `cf-${variant}`;

  const update = (prop) => (e) => setForm({ ...form, [prop]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
    sendContactMessage(form, () => {
      setForm(EMPTY);
      setHasAccepted(false);
      setIsSent(true);
    });
  };

  if (isSent) {
    return (
      <div
        className={`contact-form contact-form-${variant} contact-sent`}
        role={"status"}
      >
        <h3>Thank you!</h3>
        <p>Your message has been sent - we&apos;ll be in touch with you soon.</p>
        <button
          type={"button"}
          className={"contact-sent-again"}
          onClick={() => setIsSent(false)}
        >
          Send another message
        </button>
      </div>
    );
  }

  const isSending = sendLS === LOADING_STATE.LOADING;

  return (
    <form
      className={`contact-form contact-form-${variant}`}
      onSubmit={onSubmit}
    >
      <label
        className={"sr-only"}
        htmlFor={`${idPrefix}-name`}
      >
        Name
      </label>
      <input
        id={`${idPrefix}-name`}
        placeholder={"Name *"}
        value={form.name}
        onChange={update("name")}
        required
        autoComplete={"name"}
        maxLength={200}
      />
      <label
        className={"sr-only"}
        htmlFor={`${idPrefix}-email`}
      >
        Email
      </label>
      <input
        id={`${idPrefix}-email`}
        type={"email"}
        placeholder={"Email *"}
        value={form.email}
        onChange={update("email")}
        required
        autoComplete={"email"}
        maxLength={200}
      />
      <label
        className={"sr-only"}
        htmlFor={`${idPrefix}-phone`}
      >
        Phone
      </label>
      <input
        id={`${idPrefix}-phone`}
        type={"tel"}
        placeholder={"Phone"}
        value={form.phone}
        onChange={update("phone")}
        autoComplete={"tel"}
        maxLength={30}
      />
      <label
        className={"sr-only"}
        htmlFor={`${idPrefix}-subject`}
      >
        Subject
      </label>
      <input
        id={`${idPrefix}-subject`}
        placeholder={"Subject"}
        value={form.subject}
        onChange={update("subject")}
        maxLength={200}
      />
      <label
        className={"sr-only"}
        htmlFor={`${idPrefix}-message`}
      >
        Message
      </label>
      <textarea
        id={`${idPrefix}-message`}
        placeholder={"Type your message here... *"}
        value={form.message}
        onChange={update("message")}
        required
        rows={5}
        maxLength={5000}
      />
      {/* Honeypot - hidden from people and screen readers, bots fill it in */}
      <input
        className={"contact-hp"}
        type={"text"}
        name={"website"}
        tabIndex={-1}
        autoComplete={"off"}
        aria-hidden={"true"}
        value={form.website}
        onChange={update("website")}
      />
      <label className={"contact-accept"}>
        <input
          type={"checkbox"}
          checked={hasAccepted}
          onChange={(e) => setHasAccepted(e.target.checked)}
          required
        />
        <span>
          I accept the terms &amp; conditions in the{" "}
          <Link to={PAGE_ROUTES.PRIVACY}>privacy policy</Link>
        </span>
      </label>
      <div className={"contact-submit-row"}>
        <button
          type={"submit"}
          className={"contact-submit"}
          disabled={isSending}
        >
          {isSending ? "Sending..." : "Submit"}
        </button>
      </div>
    </form>
  );
};

const mapStateToProps = (state) => {
  return {
    sendLS: notifSelectors.getLoadState(state)(LS_ITEM.CONTACT_SEND),
  };
};

const connected = connect(
  mapStateToProps,
  {
    sendContactMessage: _contact.actions.sendContactMessage,
  },
)(ContactForm);

export default connected;
